export const TESTIMONIAL_DELETE_RESET = 'TESTIMONIAL_DELETE_RESET';
export const TESTIMONIAL_DELETE_SET_ERROR = 'TESTIMONIAL_DELETE_SET_ERROR';
export const TESTIMONIAL_DELETE_SET_DELETED = 'TESTIMONIAL_DELETE_SET_DELETED';
export const TESTIMONIAL_DELETE_TOGGLE_LOADING = 'TESTIMONIAL_DELETE_TOGGLE_LOADING';



// WEBPACK FOOTER //
// ./src/store/modules/testimonial/delete/mutation_types.js